


























































import Vue from "vue"
import {Office} from "@/model/entity/office/office"
import OfficeRangeTable from "@/components/office-range-table/OfficeRangeTable.vue"

interface Data {
  ranges: Office[]
  size: number
  addRangeDisabled: boolean
  rangeAddConfirmation: boolean
  validationMessage: string
}

export default Vue.extend({
  components: {OfficeRangeTable},
  data(): Data {
    return {
      ranges: [],
      size: 0,
      addRangeDisabled: true,
      rangeAddConfirmation: false,
      validationMessage: ""
    }
  },
  props: {
    office: {
      type: Object as () => Office,
      required: true
    }
  },
  methods: {
    addNewRange() {
      const vm = this
      this.rangeAddConfirmation = false
      this.$http
        .post("/range_office/add_range_to_office", trimDeep({
          size: vm.size,
          officeId: vm.office.id
        }))
        .then(() => {
          vm.size = 0
          vm.getRanges()
        })
        .catch(() => vm.$error(vm.$t("user_administration.range_error").toString()))
    },
    handleSizeChange() {
      const vm = this
      if (exists(vm.office.id)) {
        this.$http
          .post("/range_office/validate_range_amount/", {
            size: vm.size,
            officeId: vm.office.id
          })
          .then((response: any) => {
            vm.addRangeDisabled = !response.data.available
            vm.validationMessage = response.data.message
          })
      }
    },
    getRanges() {
      const vm = this
      if (exists(vm.office.id)) {
        this.$http.get("/range_office/by_office/" + vm.office.id).then(response => {
          vm.ranges = response.data
        })
      } else {
        vm.ranges = []
      }
    }
  },
  watch: {
    office: {
      immediate: true,
      handler() {
        this.size = this.$store.getters.ranges.minAmount
        this.handleSizeChange()
        this.getRanges()
      }
    }
  }
})
